import { makeStyles } from "@material-ui/core/styles";

const useDrawerContentStyles = makeStyles((theme) => ({
  drawerContent: {
    width: "240px",
  },
}));

export default useDrawerContentStyles;
